import templateUrl from "servicestack/auto-query/auto-query-nav.htm";
import Controller from "servicestack/auto-query/auto-query-nav.controller";

export default {
  bindings: {
    //db: '<ngModel',
    query: "<",
    nav: "<"
  },
  require: {
    //container: '^shoppingContainer'
  },
  controller: Controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
